import { render, staticRenderFns } from "./TheHomeLeftBottom.vue?vue&type=template&id=03648726&scoped=true"
import script from "./TheHomeLeftBottom.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheHomeLeftBottom.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TheHomeLeftBottom.vue?vue&type=style&index=0&id=03648726&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03648726",
  null
  
)

export default component.exports